import classNames from 'classnames';
import DownloadSVG from 'public/icons/download.svg';
import PdfSVG from 'public/icons/pdf.svg';
import { useTypograf } from '@/shared/hooks/use-typograf';
import Button from '../Button';
import Link from '../Link';

interface Props {
    title?: string;
    href?: string;
    className?: string;
}

const DownloadPdfBtn = ({ title, href, className }: Props) => {
    const tpTitle = useTypograf(title || 'Скачать программу');
    const isLink = Boolean(href);

    return (
        <Button
            tag={isLink ? Link : 'button'}
            href={href}
            target={isLink ? '_blank' : undefined}
            rel={isLink ? 'noreferrer nofollow' : undefined}
            className={classNames(
                'favorite-window-download-btn',
                !isLink && 'js-favorite-window-download-btn',
                className,
            )}
            onClick={
                isLink
                    ? undefined
                    : () => {
                          document.dispatchEvent(new CustomEvent('startDownloadPdf'));
                      }
            }
        >
            <div className="presentation-btn-left">
                <PdfSVG className="pdf-svg" />
                <div className="text-xs">{tpTitle}</div>
            </div>
            <div className="download-loader-wrapper">
                <div className="download-loader"></div>
            </div>
            <DownloadSVG className="download-svg" />
            <div className="presentation-btn-error text-xs">Что то пошло не так</div>
        </Button>
    );
};

export default DownloadPdfBtn;
